export default {
    install(Vue) {

        Vue.prototype._loaderObj = null;

        Vue.prototype.showLoadingbar = function(isShowFlag) {
            isShowFlag = (isShowFlag == null ? true : isShowFlag);
            if(isShowFlag) {
                if(this._loaderObj != null) {
                    if(!this._loaderObj.isActive) {
                        this._loaderObj = this.$loading.show();
                    }
                } else {
                    this._loaderObj = this.$loading.show();
                }
            } else {
                if(this._loaderObj != null) {
                    if(this._loaderObj.isActive) {
                        this._loaderObj.hide();
                    }
                }
                else {
                    this._loaderObj = this.$loading.show();
                    this._loaderObj.hide();
                }
            }
        }
        
        Vue.prototype.hideLoadingbar = function() {
            if(this._loaderObj != null) {
                this._loaderObj.hide();
            }
        }
        
        Vue.prototype.toggleLoadingbar = function() {
            if(this._loaderObj != null) {
                if(this._loaderObj.isActive) {
                    this._loaderObj.hide();
                } else {
                    this._loaderObj = this.$loading.show();
                }
            }
            else {
                this._loaderObj = this.$loading.show();
            }
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/js/store/module/common/showLoadingbarFunction.js